import {
  Component, Output, EventEmitter, OnInit, Inject
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {
  activation_labels,
  regex,
  tooltip_delay,
} from '../../utils/constants.helper';
import { LoginModal } from '../../models/login.model';
import { UserDetailsModel } from '../../models/userdetails.model';
import { LoginService } from '../../services/login.service';
import { environment } from '../../../../environments/environment';
import { OtpdataModel } from '../../models/otpdata.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @Output() loginClick = new EventEmitter();

  @Output() openFAQ = new EventEmitter();

  protected readonly labels = activation_labels.validation;

  protected readonly tooltipDelay = tooltip_delay;

  validationForm!: FormGroup;

  formError: boolean = false;

  formErrorMessage!: string;

  loading: boolean = false;

  loginModal!: LoginModal;

  userDetails!: UserDetailsModel;

  constructor(
    public dialog: MatDialog,
    private loginService: LoginService,
    @Inject(Window) private window: Window
  ) {}

  ngOnInit() {
    this.validationForm = new FormGroup({
      employeeNo: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.EMPLOYEE_NUMBER_REGEX),
      ]),
      cardNo: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.CARD_NUMBER_REGEX),
      ]),
    });

    const urlParams = new URLSearchParams(this.window.location.search);
    if (urlParams.has('reference')) {
      this.decryptUserDetails(urlParams.get('reference'));
    }

    this.loginService.isLoginRedirect.subscribe((detail) => {
      if (detail) {
        this.loginService.tokenExpiredMessage.subscribe((message) => {
          this.formError = true;
          this.formErrorMessage = message ?? '';
        });
      }
    });
  }

  decryptUserDetails(reference: any): void {
    this.loginService.decryptUserDetails(reference).subscribe(
      (details) => {
        this.validationForm.get('employeeNo')?.setValue(details.employeeId);
        this.validationForm.get('cardNo')?.setValue(details.sdcCardNo);
      },
      (error) => {
        this.formError = true;
        this.formErrorMessage = error;
      }
    );
  }

  saveOtpData() {
    const data: OtpdataModel = {
      employeeNo: this.userDetails.employeeId,
      cardNo: this.userDetails.sdcCardNo,
      email: this.userDetails.email ? this.userDetails.email : '',
      mobile: this.userDetails.phone ? this.userDetails.phone : '',
      preferredDevice: this.userDetails.email ? 'Email' : 'Mobile',
      clientID: environment.apigee_sdc_clientid,
      apiDomain: environment.apigee_sdc_base_url,
      purpose: 'activation',
    };
    this.loginService.updateOtpServiceData(data);
  }

  validateDetails() {
    this.formError = !this.validationForm.valid;

    if (this.validationForm.valid) {
      this.loginModal = new LoginModal();
      this.loginModal.employeeId = this.validationForm.get('employeeNo')?.value;
      this.loginModal.sdcCardNo = this.validationForm.get('cardNo')?.value;
      this.loading = true;
      this.loginService.validate(this.loginModal).subscribe(
        (response) => {
          this.loading = false;
          this.userDetails = response;
          if (!response.email && !response.phone) {
            this.formError = true;
            this.formErrorMessage = this.labels.MISSING_MOBILE_EMAIL_ERROR;
          } else {
            this.saveOtpData();
            this.loginClick.emit();
          }
        },
        (error) => {
          this.formError = true;
          this.loading = false;
          this.formErrorMessage = error;
        }
      );
    }
  }
}
